import React, { useState, useEffect, useRef } from 'react';
import { Navigate, useParams } from "react-router-dom";

import { Helmet } from 'react-helmet';
import Grid from '@mui/material/Grid2';

import { 
  Character 
} from "@dndModels";
import { DATA_TYPE_INFO } from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../utilities/common_utilities';

import CharacterSheet from "@dndComponents/character/CharacterSheet";
import LoadingBox from "@components/input/LoadingBox";
import CharacterSaveTools from "@dndComponents/character/misc/CharacterSaveTools";

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterDetails() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  // const [last_reload, setLastReload] = useState(0);
  const [logging_in, setLoggingIn] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Character>(new Character());
  const [name_for_helmet, setNameForHelmet] = useState(obj.name);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
  
  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      if (api.user === null) {
        const userObjStr = localStorage.getItem("loginUser");
        if (!userObjStr) {
          setNavigateTo("/labs");
        } else {
          setLoggingIn(true);
          setLoadingMessage("Logging in");
          check_login();
        }
      } else {
        // console.log("60");
        load();
      }
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const check_login = () => {
    setTimeout(() => {
      if (api.user === null) {
        check_login();
      } else {
        // console.log("77");
        load();
      }
    }, 1000);
  }

  const load = () => {
    // console.log("84");
    if (id && id !== "" && obj._id !== id) {
      setLoading(true);
      load_object(id);
    } else {
      setLoading(false);
    }
    setLoggingIn(false);
    setFetched(true);
  }

  // Loads the editing Character into state
  const load_object = (id: string) => {
    const onProgress = (data_type: string, percent: number ) => {
      const dt_info = DATA_TYPE_INFO.find(o => o.data_type === data_type);
      // console.log(dt_info);
      // console.log(percentage);
      // debugger;
      if (dt_info) {
        setLoadingMessage(`Loading ${dt_info.plural}`);
      } else if (data_type === "Processing") {
        setLoadingMessage("Processing");
      } else {
        setLoadingMessage(`Loading ${data_type}`);
      }
      setPercentage(percent * 100);
    };
    const onError = (message: string) => {
      setLoadingMessage(message);
    };
    // console.log("Loading");
    char_util.getCharacter({ id, onProgress, onError }).then(res => {
      if (res) {
        setObj(res);
        setNameForHelmet(res.name);
        res.subscription_holder.subscribe("Reload", mounted, onReload);
        setLoading(false);
      }
    });
  }

  const onReload = () => {
    if (id && id !== "" && obj._id !== id) {
      setLoading(true);
      // console.log("126");
      load_object(id);
    } 
  }

  const updateCharacter = (character: Character, pieces: string[]) => {
    if (pieces.length !== 1 || pieces[0] !== "reload") {
      character.changed();
      // setLastReload(common_util.get_time_number());
      setObj(character);
    } else {
      setObj(character);
      setReloading(true);
    }
  }

  if (!fetched || logging_in || loading) {
    // const height = window.innerHeight - 200;
    // return (<LoadingBox message={loading_message} size={height * 0.5} height={height} width={window.innerWidth - 17} />);
    return (<div className="centered"><LoadingBox message={loading_message} percentage={percentage} size={window.innerHeight * 0.5} height={window.innerHeight - 100} /></div>);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (logging_in) {
    return <span>Logging in</span>;
  } else if (api.user === null) {
    return <Navigate to="/dandd" />;
  } else { 
    return (
      <Grid container spacing={0} direction="row">
        <Helmet>
          <title>Homebrew Labs - { `Character Sheet: ${name_for_helmet}` }</title>
        </Helmet>
        <Grid
          size={{
            xs: 12
          }}>
          <CharacterSaveTools
            character={obj}
            // last_reload={last_reload}
            // onReload={(changed: Character) => {
            //   updateCharacter(changed, ["reload"]);
            // }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          { !reloading && 
            <CharacterSheet
              character={obj}
              updateCharacter={(obj: Character, pieces: string[] = ["all"]) => {
                updateCharacter(obj, pieces);
              }}
            />
          }
        </Grid>
      </Grid>
    ); 
  }
}
